export enum CustomerStatusEnum{
    Active = 1,
    Suspended = 2,
    Deleted = 3,
    Archived = 4
}